/**
 * Set the search filters.
 *
 * @param state
 * @param filters
 */
export const setFilters = (state, filters) => {
    localStorage.setItem('filters', JSON.stringify(filters));

    state.filters = filters;
};

/**
 * Set the search query.
 *
 * @param state
 * @param query
 */
export const setSearchQuery = (state, query) => {
    localStorage.setItem('query', JSON.stringify(query));
    state.searchQuery = query;
    Event.fire('search-updated', { query });
};

/**
 * Set the search records cache, so a search request does not have to be repeated on returning to the records table
 * view.
 *
 * @param state
 * @param {Object} search
 */
export const setSearchCache = (state, search) => {
    state.searchCache = search;
};

/**
 * Set the upcoming events in the store.
 *
 * @param state
 * @param upcomingEvents
 */
export const setUpcomingEvents = (state, upcomingEvents) => {
    state.upcomingEvents = upcomingEvents;
};

export const lockSearchInProgress = (state) => {
    state.searchInProgress = true;
};

export const unlockSearchInProgress = (state) => {
    state.searchInProgress = false;
};

/**
 * Set whether we can access the API or not.
 *
 * @param state
 * @param status
 */
export const setApiStatus = (state, status) => {
    state.onlineStatus.api = status;
};


/**
 * Set whether we can access the web or not.
 *
 * @param state
 * @param status
 */
export const setWebStatus = (state, status) => {
    state.onlineStatus.web = status;
};

/**
 * Set the selected person when they are clicked on from the records view.
 *
 * @param state
 * @param person
 */
export const setSelectedPerson = (state, person) => {
    state.selectedPerson = person;
};

/**
 * Update the race number on a given entry ID.
 *
 * @param state
 * @param entryId
 * @param newNumber
 */
export const updateRaceNumber = (state, { entryId, newNumber }) => {
    let index = state.selectedPerson.upcoming_entries
        .findIndex(entry => entry.id === entryId);

    state.selectedPerson.upcoming_entries.splice(index, 1, {
        ...state.selectedPerson.upcoming_entries[index],
        race_number: newNumber
    });
};
